export default __webpack_public_path__ + "static/media/trr-food-worb_tunasaladbowl.822bbb90.png";